module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1501-70746328f11fcd6be39c07288d2248ef.png";